// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Roboto Mono', 'Roboto Mono Fallback'","fontWeight":600,"fontStyle":"normal"},"className":"__className_4c3c58"};